<template>
  <div
    class="d-flex flex-column flex-1-1 ga-3"
    style="
      --task-pane-skeleton-base: #e1e5e8;
      --task-pane-skeleton-mid: #edf0f2;
      --task-pane-skeleton-highlight: #fafbfc;
    "
  >
    <div class="d-flex align-center justify-space-between ga-3">
      <div class="task-pane-loading-skeleton__block flex-1-1" style="height: 38px" />
      <div class="task-pane-loading-skeleton__block" style="flex: 0 0 94px; height: 38px; border-radius: 18px" />
    </div>

    <div class="task-pane-loading-skeleton__block w-100" style="height: 64px" />
    <div class="task-pane-loading-skeleton__block w-100" style="height: 64px" />

    <div class="d-flex flex-column ga-4" style="padding-top: 14px">
      <div class="task-pane-loading-skeleton__block w-100" style="min-height: 230px" />
      <div class="task-pane-loading-skeleton__block w-100" style="min-height: 230px" />
    </div>
  </div>
</template>

<style scoped>
.task-pane-loading-skeleton__block {
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--task-pane-skeleton-base) 0%,
    var(--task-pane-skeleton-mid) 32%,
    var(--task-pane-skeleton-highlight) 50%,
    var(--task-pane-skeleton-mid) 68%,
    var(--task-pane-skeleton-base) 100%
  );
  background-size: 240% 100%;
  animation: task-pane-loading-shimmer 1.35s ease-in-out infinite;
}

@keyframes task-pane-loading-shimmer {
  100% {
    background-position-x: -240%;
  }
}
</style>
